import { ReactNode } from "react";
import { createContext, useContext } from "react";

interface AddressMapContextValue {
  data?: AddressMapData;
  isLoading: boolean;
  isError: boolean;
  error?: Error | null;
}

const AddressMapContext = createContext<AddressMapContextValue | undefined>(undefined);

export function useAddressMapContext() {
  const context = useContext(AddressMapContext);
  if (!context) {
    throw new Error('useAddressMapContext must be used within AddressMapProvider');
  }
  return context;
}

interface AddressMapProviderProps {
  children: ReactNode;
  value: AddressMapContextValue;
}

export function AddressMapProvider({ children, value }: AddressMapProviderProps) {
  return (
    <AddressMapContext.Provider value={value}>{children}</AddressMapContext.Provider>
  );
}

export interface AddressMapData {
  mapSasUrl?: string | null;
  centerLatitude?: number | null;
  centerLongitude?: number | null;
  zoomLevel?: number | null;
}
